module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAiAQAAAABdYTW/AAAADUlEQVQI12M4wEAxBABjcRmB+wIecAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_vertical_line.png
// module id = grFS
// module chunks = 5